import classNames from "classnames";
import React, { useMemo } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useCareCommentThreadList } from "../../hooks/care_comment/useCareCommentThreadList";
import { CareCommentThreadItem } from "./CareCommentThreadItem";
import { NoData } from "../common/no_data/NoData";

export const PinnedCareCommentList = React.memo(function PinnedCareCommentList() {
    const careCommentThreadList = useCareCommentThreadList();

    const pinnedCareCommentThreadList = useMemo(() => (
        careCommentThreadList ? careCommentThreadList.filter(careCommentThread => careCommentThread.isPinned) : []
    ), [careCommentThreadList]);

    if (!pinnedCareCommentThreadList || !pinnedCareCommentThreadList.length) return <NoData message={"継続掲示中のケアコメントがありません"} />;

    return (
        <TransitionGroup>
            {pinnedCareCommentThreadList.map(careCommentThread =>
                <CSSTransition key={`${careCommentThread.id.value}Pinned`} timeout={500} classNames={"item"}>
                    <li className={classNames("care_comment_row", { "mark_as_read": careCommentThread.careComments.every(careComment => careComment.isRead) })}>
                        <CareCommentThreadItem careCommentThread={careCommentThread} />
                    </li>
                </CSSTransition>
            )}
        </TransitionGroup>
    );
});
